const HttpRequestConstants = {
  SHIPPING_FEES_STARTED: 'SHIPPING_FEES_STARTED',
  SHIPPING_FEES_SUCCESS: 'SHIPPING_FEES_SUCCESS',
  SHIPPING_FEES_FAILED: 'SHIPPING_FEES_FAILED',
  
  SHIPPING_AD_FEES_STARTED: 'SHIPPING_AD_FEES_STARTED',
  SHIPPING_AD_FEES_SUCCESS: 'SHIPPING_AD_FEES_SUCCESS',
  SHIPPING_AD_FEES_FAILED: 'SHIPPING_AD_FEES_FAILED',

  TYRE_FILTER_OPTIONS_STARTED: 'TYRE_FILTER_OPTIONS_STARTED',
  TYRE_FILTER_OPTIONS_SUCCESS: 'TYRE_FILTER_OPTIONS_SUCCESS',
  TYRE_FILTER_OPTIONS_FAILED: 'TYRE_FILTER_OPTIONS_FAILED',

  MOTO_TYRE_FILTER_OPTIONS_STARTED: 'MOTO_TYRE_FILTER_OPTIONS_STARTED',
  MOTO_TYRE_FILTER_OPTIONS_SUCCESS: 'MOTO_TYRE_FILTER_OPTIONS_SUCCESS',
  MOTO_TYRE_FILTER_OPTIONS_FAILED: 'MOTO_TYRE_FILTER_OPTIONS_FAILED',

  PRODUCT_BATCH_STOCKS_STARTED: 'PRODUCT_BATCH_STOCKS_STARTED',
  PRODUCT_BATCH_STOCKS_SUCCESS: 'PRODUCT_BATCH_STOCKS_SUCCESS',
  PRODUCT_BATCH_STOCKS_FAILED: 'PRODUCT_BATCH_STOCKS_FAILED',

  CART_MIXED_STOCKS_COMPUTE_STARTED: 'CART_MIXED_STOCKS_COMPUTE_STARTED',
  CART_MIXED_STOCKS_COMPUTE_SUCCESS: 'CART_MIXED_STOCKS_COMPUTE_SUCCESS',
  CART_MIXED_STOCKS_COMPUTE_FAILED: 'CART_MIXED_STOCKS_COMPUTE_FAILED',

  PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_STARTED: 'PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_STARTED',
  PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_SUCCESS: 'PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_SUCCESS',
  PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_FAILED: 'PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_FAILED',

  PRODUCT_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE_STARTED: 'PRODUCT_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE_STARTED',
  PRODUCT_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE_SUCCESS: 'PRODUCT_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE_SUCCESS',
  PRODUCT_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE_FAILED: 'PRODUCT_MIXED_STOCKS_SHIPPING_OPTIONS_COMPUTE_FAILED',

  CART_GET_STARTED: 'CART_GET_STARTED',
  CART_GET_SUCCESS: 'CART_GET_SUCCESS',
  CART_GET_FAILED: 'CART_GET_FAILED',

  RESET_STATUS: 'RESET_STATUS'
};

export default HttpRequestConstants;
